"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrapPosthogConfig = bootstrapPosthogConfig;
exports.captureLandingCampaignParams = captureLandingCampaignParams;
exports.capturePosthogEvent = capturePosthogEvent;
exports.getPosthogSessionId = getPosthogSessionId;
exports.initPosthog = initPosthog;
exports.setPosthogTrackingEnabled = setPosthogTrackingEnabled;
exports.shouldTrackWebPosthog = shouldTrackWebPosthog;
exports.syncPosthogUser = syncPosthogUser;
var _internal = require("./_internal");
var _is_present = _interopRequireDefault(require("./is_present"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var DEFAULT_POSTHOG_HOST = 'https://eu.i.posthog.com';
var CAMPAIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
var fetchedPosthogConfig = null;
var FIRST_TOUCH_STORAGE_KEY = 'seedlang-posthog-first-touch';
var landingCampaignProperties = {};
var firstTouchCampaignProperties = {};
function analyticsMembershipTypeId(user, site) {
  var _user$userGroupForSit;
  if (!site || site.isSeedlang) {
    return user && user.membershipTypeId;
  }
  if (typeof (user === null || user === void 0 ? void 0 : user.userGroupForSite) !== 'function') {
    return null;
  }
  return user === null || user === void 0 || (_user$userGroupForSit = user.userGroupForSite(site)) === null || _user$userGroupForSit === void 0 ? void 0 : _user$userGroupForSit.membershipTypeId;
}
function posthogPersonProperties(user, site) {
  var promotion = user && user.signedUpWithPromotion;
  return (0, _internal.compactObject)({
    email: user && user.email,
    name: user && user.name,
    language_id: user && user.languageId,
    target_language_id: user && user.targetLanguageId,
    level_id: user && user.levelId,
    level_abbreviation: user && user.levelAbbreviation,
    membership_type_id: analyticsMembershipTypeId(user, site),
    language_signed_up_with: user && user.languageSignedUpWith,
    pro: Boolean(user && user.membershipTypeId),
    experiment: user && user.experiment,
    is_member: user && user.isMember,
    permanent_membership: user && user.permanentMembership,
    guest: user && user.guest,
    converted_from_guest: user && user.convertedFromGuest,
    promotion_slug: promotion && promotion.slug,
    learning_preference: user && user.learningPreference,
    country_code: user && user.countryCode,
    site_id: site && site.id,
    site_name: site && site.teamName || site && site.name
  });
}
function browserSupportsPosthog() {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && typeof globalThis !== 'undefined' && typeof Promise !== 'undefined' && typeof Promise.prototype["finally"] === 'function';
}
function browserSupportsPosthogPerformanceCapture() {
  return typeof PerformanceObserver !== 'undefined' && Array.prototype && typeof Array.prototype.at === 'function';
}
function isDebugLoggingHost() {
  if (!browserSupportsPosthog()) {
    return false;
  }
  var hostname = window.location && window.location.hostname;
  return Boolean(hostname && (['localhost', '127.0.0.1'].includes(hostname) || hostname.endsWith('.ngrok.io')));
}
function metaContent(name) {
  var metaTag = typeof document.querySelector === 'function' ? document.querySelector("meta[name=\"".concat(name, "\"]")) : null;
  return metaTag ? metaTag.getAttribute('content') : null;
}
function posthogHostToAssetHost(host) {
  return host.includes('.i.posthog.com') ? host.replace('.i.posthog.com', '-assets.i.posthog.com') : host;
}
function initializedPosthog() {
  if (!browserSupportsPosthog() || !window.__seedlangPosthogInitialized) {
    return null;
  }
  return window.posthog || null;
}
function installSnippet() {
  if (!browserSupportsPosthog()) {
    return null;
  }
  var existingPosthog = window.posthog;
  if (existingPosthog && existingPosthog.__SV) {
    return existingPosthog;
  }
  var posthog = existingPosthog || [];
  posthog.init = function init(apiKey, config, name) {
    function makeStub(target, methodName) {
      var parts = methodName.split('.');
      var stubTarget = target;
      var stubMethod = methodName;
      if (parts.length === 2) {
        stubTarget = target[parts[0]];
        stubMethod = parts[1];
      }
      stubTarget[stubMethod] = function posthogStub() {
        stubTarget.push([stubMethod].concat(Array.prototype.slice.call(arguments, 0)));
      };
    }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    script.async = true;
    script.src = posthogHostToAssetHost(config.api_host || DEFAULT_POSTHOG_HOST) + '/static/array.js';
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
    var instance = posthog;
    var instanceName = name;
    if (typeof instanceName !== 'undefined') {
      instance = posthog[instanceName] = [];
    } else {
      instanceName = 'posthog';
    }
    instance.people = instance.people || [];
    instance.toString = function toString(stub) {
      var str = 'posthog';
      if (instanceName !== 'posthog') {
        str += ".".concat(instanceName);
      }
      if (!stub) {
        str += ' (stub)';
      }
      return str;
    };
    instance.people.toString = function peopleToString() {
      return instance.toString(1) + '.people (stub)';
    };
    var methods = 'init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug'.split(' ');
    for (var i = 0; i < methods.length; i += 1) {
      makeStub(instance, methods[i]);
    }
    posthog._i.push([apiKey, config, instanceName]);
  };
  window.posthog = posthog;
  posthog._i = posthog._i || [];
  posthog.__SV = 1;
  return posthog;
}
function getPosthogConfig() {
  if (!browserSupportsPosthog()) {
    return {};
  }
  if (fetchedPosthogConfig) {
    return fetchedPosthogConfig;
  }
  return {
    apiKey: metaContent('seedlang-posthog-api-key') || process.env.REACT_APP_POSTHOG_API_KEY,
    host: metaContent('seedlang-posthog-host') || process.env.REACT_APP_POSTHOG_HOST || DEFAULT_POSTHOG_HOST
  };
}

// PostHog may only initialize after cookie consent or after client-side routing
// has dropped the query string, so the landing URL's campaign params are kept in
// memory until then and only persisted by PostHog once tracking is allowed.
function captureLandingCampaignParams() {
  if (!browserSupportsPosthog() || typeof URLSearchParams === 'undefined') {
    return;
  }
  var searchParams = new URLSearchParams(window.location.search);
  landingCampaignProperties = CAMPAIGN_PARAMS.reduce(function (result, param) {
    var value = searchParams.get(param);
    if ((0, _is_present["default"])(value)) {
      result["first_touch_".concat(param)] = value;
    }
    return result;
  }, {});
}
function bootstrapPosthogConfig() {
  return _bootstrapPosthogConfig.apply(this, arguments);
}
function _bootstrapPosthogConfig() {
  _bootstrapPosthogConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var existingConfig, response, json, apiKey, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (browserSupportsPosthog()) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          existingConfig = getPosthogConfig();
          if (!existingConfig.apiKey) {
            _context.n = 2;
            break;
          }
          return _context.a(2, existingConfig);
        case 2:
          _context.p = 2;
          _context.n = 3;
          return fetch('/api/posthog_config');
        case 3:
          response = _context.v;
          if (response.ok) {
            _context.n = 4;
            break;
          }
          return _context.a(2, null);
        case 4:
          _context.n = 5;
          return response.json();
        case 5:
          json = _context.v;
          apiKey = json && (json.apiKey || json.api_key);
          if (apiKey) {
            _context.n = 6;
            break;
          }
          return _context.a(2, null);
        case 6:
          fetchedPosthogConfig = {
            apiKey: apiKey,
            host: json.host || DEFAULT_POSTHOG_HOST
          };
          return _context.a(2, fetchedPosthogConfig);
        case 7:
          _context.p = 7;
          _t = _context.v;
          return _context.a(2, null);
      }
    }, _callee, null, [[2, 7]]);
  }));
  return _bootstrapPosthogConfig.apply(this, arguments);
}
function initPosthog() {
  if (!browserSupportsPosthog()) {
    return null;
  }
  var _getPosthogConfig = getPosthogConfig(),
    apiKey = _getPosthogConfig.apiKey,
    host = _getPosthogConfig.host;
  if (!apiKey) {
    return null;
  }
  installSnippet();
  if (!window.__seedlangPosthogInitialized) {
    if (process.env.NODE_ENV === 'development') {
      console.log('[PostHog] Initializing web SDK');
    }
    window.posthog.init(apiKey, {
      api_host: host,
      autocapture: false,
      capture_performance: browserSupportsPosthogPerformanceCapture(),
      defaults: '2026-01-30',
      before_send: fillInitialCampaignProperties
    });
    window.__seedlangPosthogInitialized = true;
  }
  return window.posthog;
}

// PostHog derives $initial_utm_* from the URL it sees when it starts, which on
// Memrev is usually after consent or a redirect has removed the campaign params.
// Filling them into PostHog's own $set_once keeps them first-touch.
function fillInitialCampaignProperties(event) {
  var setOnceProperties = event && event.$set_once;
  if (!setOnceProperties || !(0, _is_present["default"])(firstTouchCampaignProperties)) {
    return event;
  }
  CAMPAIGN_PARAMS.forEach(function (param) {
    var initialKey = "$initial_".concat(param);
    var value = firstTouchCampaignProperties["first_touch_".concat(param)];
    if ((0, _is_present["default"])(value) && !(0, _is_present["default"])(setOnceProperties[initialKey])) {
      setOnceProperties[initialKey] = value;
    }
  });
  return event;
}
function restoreFirstTouchCampaignProperties(posthog) {
  if ((0, _is_present["default"])(firstTouchCampaignProperties)) {
    return;
  }
  var storedCampaignProperties = storedFirstTouchCampaignProperties();
  firstTouchCampaignProperties = (0, _is_present["default"])(storedCampaignProperties) ? storedCampaignProperties : landingCampaignProperties;
  if ((0, _is_present["default"])(firstTouchCampaignProperties)) {
    storeFirstTouchCampaignProperties(firstTouchCampaignProperties);
    posthog.register_once(firstTouchCampaignProperties);
  }
}
function storedFirstTouchCampaignProperties() {
  try {
    return JSON.parse(window.localStorage.getItem(FIRST_TOUCH_STORAGE_KEY)) || {};
  } catch (error) {
    return {};
  }
}
function storeFirstTouchCampaignProperties(properties) {
  try {
    window.localStorage.setItem(FIRST_TOUCH_STORAGE_KEY, JSON.stringify(properties));
  } catch (error) {
    // Storage can be unavailable in private windows; events still carry the values for this page.
  }
}
function clearFirstTouchCampaignProperties() {
  firstTouchCampaignProperties = {};
  try {
    window.localStorage.removeItem(FIRST_TOUCH_STORAGE_KEY);
  } catch (error) {
    // Nothing was stored if storage is unavailable.
  }
}
function resetPosthog(posthog) {
  posthog.reset();
  clearFirstTouchCampaignProperties();
  delete window.__seedlangPosthogDistinctId;
  delete window.__seedlangPosthogIdentifyKey;
}
function shouldTrackWebPosthog(_ref) {
  var siteIsSeedlang = _ref.siteIsSeedlang,
    user = _ref.user,
    allowCookies = _ref.allowCookies;
  if (!browserSupportsPosthog()) {
    return false;
  }
  if (!user || !user.signedOut && !user.id) {
    return false;
  }
  if (user && user.blockUserTracking) {
    return false;
  }
  if (siteIsSeedlang) {
    return true;
  }
  var privacySettings = user.privacySettings;
  if (privacySettings && typeof privacySettings.allowCookies !== 'undefined') {
    return Boolean(privacySettings.allowCookies);
  }
  return Boolean(allowCookies);
}
function setPosthogTrackingEnabled(enabled) {
  var posthog = enabled ? initPosthog() : initializedPosthog();
  if (!posthog) {
    return false;
  }
  if (enabled) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
  return true;
}
function syncPosthogUser(user) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    trackingAllowed = _ref2.trackingAllowed,
    site = _ref2.site;
  if (!trackingAllowed) {
    clearFirstTouchCampaignProperties();
    var _posthog = initializedPosthog();
    if (!_posthog) {
      return false;
    }
    setPosthogTrackingEnabled(false);
    if (window.__seedlangPosthogDistinctId) {
      resetPosthog(_posthog);
    }
    return false;
  }
  var posthog = initPosthog();
  if (!posthog) {
    return false;
  }
  setPosthogTrackingEnabled(true);
  restoreFirstTouchCampaignProperties(posthog);
  if (user && user.id && !user.signedOut) {
    var distinctId = String(user.id);
    var personProperties = posthogPersonProperties(user, site || user.site);
    var identifyKey = JSON.stringify([distinctId, personProperties]);
    if (window.__seedlangPosthogIdentifyKey !== identifyKey) {
      posthog.identify(distinctId, personProperties, firstTouchCampaignProperties);
      window.__seedlangPosthogDistinctId = distinctId;
      window.__seedlangPosthogIdentifyKey = identifyKey;
    }
    return true;
  }
  if (window.__seedlangPosthogDistinctId) {
    resetPosthog(posthog);
  }
  return true;
}
function capturePosthogEvent(eventType) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var posthog = initializedPosthog();
  if (!posthog) {
    return false;
  }
  if (isDebugLoggingHost()) {
    console.log('[PostHog frontend event]', {
      eventType: eventType,
      properties: properties
    });
  }
  posthog.capture(eventType, properties);
  return true;
}
function getPosthogSessionId() {
  var posthog = initializedPosthog();
  if (!posthog || typeof posthog.get_session_id !== 'function') {
    return null;
  }
  return posthog.get_session_id();
}